import React from 'react'
import { createBrowserRouter, Navigate } from 'react-router-dom'

import * as Constants from './../../helpers/constants'
import UserlistPage from '../user_list_page'
import TrialPeriods from '../trial_periods'
import MiscellaneousApi from '../miscellaneous'
import ClearoutIndividualUserInfo from '../individual_user_info/clearout_individual_user_info'
import ProductList from './../products/component/list'
import CreateProduct from './../products/component/create'
import OrganizationInfo from '../org_info/org_info'
// import Coupons from '../coupons/coupons'
import OrgListPage from '../org_list_page'
import ManageAbuse from '../abuse/manage_abuse'
import UpdateHistory from '../update_history/abuse_update_history'
import AbuseLogs from '../abuse_view_logs/abuse_view_logs'
import UserActivities from '../user_activities/user_activities'
import ServiceLists from '../service_list'
import MembersList from '../members_list/members_list'
import GeneratePurchaseURL from './../products/component/generate_url'

const CLIENT = Constants.CLIENTS.SPOKESLY_CLEAROUT.NAME

const clearoutSpokeslyRouter = createBrowserRouter([
  {
    id: 'dashboard-spokesly-route',
    path: CLIENT,
    children: [
      {
        id: 'dashboard-spokesly-users',
        path: 'users',
        element: <UserlistPage />
      },
      {
        id: 'dashboard-spokesly-ev-list',
        path: 'email_verifier_lists',
        element: <ServiceLists service={Constants.SERVICE_TYPES.EMAIL_VERIFIER} />
      },
      {
        id: 'dashboard-spokesly-org-members-list',
        path: 'org_members_list',
        element: <MembersList />
      },
      {
        id: 'spokesly-individual-user-info',
        path: 'individual_user_info',
        element: <ClearoutIndividualUserInfo />
      },
      {
        id: 'dashboard-spokesly-org-users',
        path: 'org_list',
        element: <OrgListPage />
      },
      {
        id: 'spokesly-dashboard-user-activities',
        path: 'individual_user_activity',
        element: <UserActivities />
      },
      {
        id: 'dashboard-spokesly-clearout-miscellaneous-api',
        path: 'miscellaneous_api',
        element: <MiscellaneousApi />
      },
      {
        id: 'clearout-spokesly-plan-list',
        path: 'plan_list',
        element: <ProductList />
      },
      {
        id: 'clearout-spokesly-create-plan',
        path: 'create_plan',
        element: <CreateProduct />
      },
      {
        id: 'clearout-spokesly-organization-info',
        path: 'organization_info',
        element: <OrganizationInfo />
      },
      {
        id: 'clearout-spokesly-generate-purchase-url',
        path: 'generate_purchase_url',
        element: <GeneratePurchaseURL />
      },
      {
        id: 'clearout-spokesly-manage-abuse',
        path: 'abuse_list',
        element: <ManageAbuse />
      },
      {
        id: 'clearout-spokesly-view-logs',
        path: 'abuse_logs',
        element: <AbuseLogs />
      },
      {
        id: 'clearout-spokesly-update-logs',
        path: 'abuse_update_logs',
        element: <UpdateHistory />
      },
      {
        id: CLIENT + '-trial-periods',
        path: 'trial_periods',
        element: <TrialPeriods />
      },
      {
        id: CLIENT + '-redirect',
        path: '*',
        element:
          <Navigate
            to={'users'}
            replace={true}
          />
      },
    ]
  },

])

export default clearoutSpokeslyRouter
